<template>
  <div class="login">
    <Header></Header>
    <div class="main-content clearfix">
      <div class="login-box">
        <div class="left-add">
          <img src="@/assets/images/login_bg.jpg" alt="登录">
        </div>
        <div class="right-login">
          <!-- 登录  -->
          <div v-if="login" class="login-content" id="login-main" style="">     
            <ul class="login-tab">
              <li data-type="1" @click="LoginTabClick(1)" :class="ClassActive == 1 ? 'active' : ''">密码登录</li>
              <li data-type="2" @click="LoginTabClick(2)" :class="ClassActive == 2 ? 'active' : ''">验证码登录</li>
            </ul>
            <div class="login-tab-pass" v-if="ClassActive === 1">
              <!-- 密码登录 -->
              <el-form 
                :model="passForm"
                status-icon 
                :rules="passRules" 
                ref="passForm" 
                class="input-box">
                <el-form-item prop="phone">
                  <el-input 
                    placeholder="请输入正确的手机号"
                    prefix-icon="el-icon-mobile-phone" 
                    v-model="passForm.phone" 
                    autocomplete="off">
                  </el-input>
                </el-form-item>
                <el-form-item prop="pass">
                  <el-input 
                    placeholder="输入不少于6位数的密码"
                    prefix-icon="el-icon-lock" 
                    type="password" 
                    v-model="passForm.pass" 
                    autocomplete="off">
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="common-btn" type="primary" @click="submitForm('ruleForm')">确认登录</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="login-tab-pass" v-if="ClassActive == 2">
              <!-- 验证码登录 -->
              <getCode />
            </div>
            <div class="operating-box flex-between">
              <el-button type="text" class="common-btn2" id="forgotpsd-btn" @click="forgotpsdClick">忘记密码？</el-button>
              <el-button type="text" class="common-btn2" id="signup-btn" @click="signupClick">免费注册</el-button>
            </div>
          </div>
          <!-- 忘记密码 -->
          <template v-if="forgotpsd">
            <ForgotPSD @loginClick="loginClick"/>
          </template>
        </div>
      </div>
      <div class="footer">
        <span class="login-footer">©2014-2023 WlhEx Inc All Rights Reserved.成都微珑汇科技有限公司 </span>
        <!-- <a class="beian-link icp-link" href="http://beian.miit.gov.cn/" target="_blank">蜀ICP备2021027653号-1</a> -->
          <!-- <span class="line gongan-line">|</span> -->
        <a class="beian-link icp-link" href="http://beian.miit.gov.cn/" target="_blank">
          <!-- <img src="data:image/png;base64,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" alt="公安备案" class="beian-img"> -->
          <span class="text">蜀ICP备2021027653号-1</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/layout/Header.vue";
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import getCode from "@/components/login/getCode.vue";
import ForgotPSD from "@/components/login/forgotpsd.vue";
// import axios from "axios";
import { mapState, mapMutations } from 'vuex'
import { Login, getUserProfile } from "@/api/api.js";
export default {
  components: {
    Header,
    getCode,
    ForgotPSD
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (/^[1-9]\d*$/.test(value) === false ) {
        callback(new Error("手机格式不正确，请重新输入!"))
      } else if (value.length !== 11) {
        callback(new Error("手机格式不正确，请重新输入!"))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("请输入不少于6位数的密码"))
      } else {
        callback()
      }
    }
    return {
      ClassActive: 1,
      login: true,
      signup: false,
      forgotpsd: false,
      // codeFlag: true,
      passForm: {
        phone: null,
        pass: ''
      },
      passRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, required: true, trigger: ['change', 'blur'] }
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, required: true, trigger: ['change', 'blur'] }
        ]
      },
      deviceID: localStorage.getItem('visitorId')
    }
  },
  created () {
    FingerprintJS.load().then(fp => {
      fp.get().then(result => {
        const visitorId = result.visitorId
        // console.log('visitorId', visitorId)
        localStorage.setItem('visitorId', visitorId)
        return visitorId
      })
    })
  },
  mounted() {
    
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    LoginTabClick (value) {
      this.ClassActive = value
      this.$refs.passForm.resetFields()
      this.$refs.passForm.clearValidate()
    },
    submitForm () {
      this.$refs.passForm.validate((valid) => {
        if (valid) {
          let userInfo = JSON.stringify({
            account: this.passForm.phone,
            password: this.passForm.pass
          })
          Login(userInfo).then((res) => {
            // console.log('res', res)
            if (res.status === 1) {
              localStorage.setItem('token', res.data)
              getUserProfile().then((res) => {
                // console.log('res', res)
                if (res.status === 1) {
                  // const userInfo = JSON.stringify(res.data)
                  this.setUserInfo(res.data)
                  // localStorage.setItem('userInfo', userInfo)
                  this.$router.push({
                    path: "/"
                  })
                }
              })
            } else {
              switch (res.status) {
                case -12:
                  this.$message({
                    message: '缺少密码',
                    type: 'error'
                  })
                  break;
                case -13:
                  this.$message({
                    message: '账号未注册',
                    type: 'error'
                  })
                  break;
                case -14:
                  this.$message({
                    message: '密码错误',
                    type: 'error'
                  })
                  break;
                case -15:
                  this.$message({
                    message: '手机格式错误',
                    type: 'error'
                  })
                  break;
                case -16:
                  this.$message({
                    message: '验证码错误',
                    type: 'error'
                  })
                  break;
              
                default:
                  break;
              }
            }
          })
        }
      })
    },
    // 注册点击
    signupClick () {
      this.login = false
      // this.signup = true
      this.forgotpsd = false
      this.$router.push('/signup')
    },
    // 忘记密码
    forgotpsdClick () {
      this.login = false
      this.signup = false
      this.forgotpsd = true
    },
    // 立即登录
    loginClick () {
      this.login = true
      this.signup = false
      this.forgotpsd = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('../assets/scss/login.scss');
</style>